/**
 * Loads a external script dynamically and ensures it is only loaded once.
 * @param url The URL of the script to load.
 * @returns A promise that resolves when the script is successfully loaded, or rejects if the script fails to load.
 */
export function loadScript(scriptUrl: string) {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptUrl;
    scriptElement.onload = resolve;
    document.body.appendChild(scriptElement);
  });
}

export function mapErrors(errors: any[]) {
  return errors.reduce((acc, error) => {
    if (typeof error === 'object') {
      acc[error.errorSlug] = error;
    } else {
      acc[error] = true;
    }
    return acc;
  }, {});
}

/**
 * Currency formatter instance for 'en-AU' locale and 'AUD' currency.
 */
export const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
});
